<template>
	<div class="con">
		<div class="title">
			这里是标题这里是标题这里是标题这里是标题这里是标题
		</div>
		<div class="flexCenter metas">
			<li>2022年2月3日 12:00</li>
		</div>
		<div class="content">
			dsadasd
		</div>
		<div class="button">
			<el-button type="primary">
				<span>
					点击报名
				</span>
			</el-button>
		</div>
		
		<!--报名列表-->
		<save />
		<!--报名列表-->
	</div>
</template>

<script>
	import save from "./components/save.vue"
	export default {
		components:{
			save
		},
		data(){
			return{
				
			}
		},
		mounted(){
			
		},
		methods:{
			
		},
	}
</script>

<style lang="scss">
	.con{
		.button{
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-top: 50px;
			span{
				text-decoration: underline;
			}
		}
		.content{
			width: 100%;
			margin-top: 30px;
		}
		width: 1200px;
		margin: 0 auto;
		.metas{
			    margin-top: 20px;
			    margin-bottom: 20px;
			    padding-bottom: 20px;
			    border-bottom: 1px solid #dfdfdf;
				color: #666;
				font-size: 14px;
		}
		.flexCenter{
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.title{
			width: 80%;
			margin: 0 auto;
			margin-top: 50px;
			font-size: 22px;
			color: #0e0e0e;
			text-align: center;
			font-weight: blod;
			line-height: 35px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/notice/detail.vue